import React from "react";
import { Link } from "react-router-dom";
import "./LegalPage.scss";

export default function TermsPage() {
  return (
    <div className="netflix-app container-fluid legal-page-shell">
      <article className="legal-page">
        <Link className="legal-page__back" to="/">← Back to dSsTV</Link>
        <h1 className="legal-page__title">Terms of Use</h1>
        <p className="legal-page__effective">
          <strong>Effective Date:</strong> March 19, 2026
        </p>
        <p className="legal-page__text">
          Welcome to dataSCIsiveTV. By accessing or using this
          website/application, you agree to be bound by these Terms of Use.
        </p>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">YouTube Terms of Service</h2>
          <p className="legal-page__text">
            dataSCIsiveTV uses YouTube API Services. By accessing or using
            dataSCIsiveTV, you also agree to be bound by the{" "}
            <a
              className="legal-page__link"
              href="https://www.youtube.com/t/terms"
              target="_blank"
              rel="noopener noreferrer"
            >
              YouTube Terms of Service
            </a>
            .
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Use of the Service</h2>
          <p className="legal-page__text">
            You may use dataSCIsiveTV only in compliance with these Terms of Use
            and all applicable laws, rules, and regulations.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Third-Party Services</h2>
          <p className="legal-page__text">
            dataSCIsiveTV may display, retrieve, or make available content, data,
            or services provided by third parties, including YouTube. Your use of
            such third-party content and services may be subject to additional
            terms and policies of those third parties.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Disclaimer</h2>
          <p className="legal-page__text">
            dataSCIsiveTV is provided on an &ldquo;as is&rdquo; and &ldquo;as
            available&rdquo; basis, without warranties of any kind, to the
            fullest extent permitted by law.
          </p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__heading">Contact</h2>
          <p className="legal-page__text">
            If you have any questions about these Terms of Use, please contact
            us at{" "}
            <a
              className="legal-page__link"
              href="mailto:s@dataSCIsive.com"
            >
              s@dataSCIsive.com
            </a>
            .
          </p>
        </section>
      </article>
    </div>
  );
}
